module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(konto do wysyłania)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.show',
          params: {
            id: _vm.item.id
          }
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj konto")])], 1), _vm._v(" "), (_vm.item) ? _c('accounts-test-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119ecc0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/Test.vue
// module id = 226
// module chunks = 0